import React, { Component } from 'react';
import {
  TextInput,
  Button,
  FormGroup,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownSkeleton,
  TextArea,
} from 'carbon-components-react';
import { FindGHRSEmployer } from '../common/FindGHRSEmployer';
import { ComboBox } from '../../helpers/ComboBox';
import SimpleReactValidator from 'simple-react-validator';
import { v4 as uuid } from 'uuid';
import { DateFormat, entitiesLabels, getError, apioperation } from '../../helpers/Constants'; //RITM0946001 - Anonimizzazione Modulo Incident
import { showNotification } from '../../helpers/notification/BaseNotification';
import moment from 'moment';
import DateTimePicker from '../../helpers/DateTimePicker';
import Close16 from '@carbon/icons-react/lib/close/16';

export default class CAModal extends Component {
  incidentCARModel = (props) => {
    if (props.isEditModal) {
      let editModel = props.editModel;

      return { ...editModel };
    }

    return {
      id: undefined, //guid
      idIncidentCAR: undefined, //guid
      // idDirectCauseSubCategory: null, //guid
      // directCauseSubCategory: null, //{}
      // idRootCauseSubCategory: null, //guid
      // rootCauseSubCategory: null, //{}
      caImplemented: null, //''
      idOwner: null, //idInvolvedPerson: null,  //guid
      owner: {
        //InvolvedPerson: {
        id: null, //guid
        type: '',
        badgeNumber: '',
        fullname: '',
        nationality: '',
        email: '',
        position: '',
        idEmployer: null, //guid
      },
      dueDate: null, //Il sistema deve settarla con il valore della CAR Due Date e non può essere modificata
      dueDateChangeNotes: null, //''
      immediateThreatment: null,
      idStatus: 1,
    };
  };

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({autoForceUpdate: this, locale: 'en'});
    this.state = {
      model: {
        ...this.incidentCARModel(props),
      },
      mode: 0,
      appType: props.appType,
      appNationality: props.appNationality,
      appRecommendation: props.appRecommendation,
    };
  }

  componentDidMount() {}

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state.model);
    if (objName && objName != 'model') statusCopy[objName][inputName] = inputValue;
    else statusCopy[inputName] = inputValue;

    this.setState({ model: statusCopy });
  };
  updateStateDP = (inputName, inputValue, objName) => {
    this.setState(
      (prevState) => ({
        [objName]: {
          ...prevState[objName],
          [inputName]: inputValue,
        },
      }),
      () => {
        this.incidentCARModel(inputName, inputValue);
      }
    );
  };
  handleChangeModel = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;
    let objName = el.target.alt;

    this.updateState(inputName, inputValue, objName);
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    let inputValue = selectedItem ? selectedItem.id : null;
    this.updateState(inputName, inputValue, objName);
  };

  deleteEmployer = () => {
    let statusCopy = Object.assign({}, this.state.model);
    statusCopy.owner.id = null;
    statusCopy.owner.idEmployer = null;
    statusCopy.owner.type = null;
    statusCopy.owner.badgeNumber = null;
    statusCopy.owner.fullname = null;
    statusCopy.owner.nationality = null;
    statusCopy.owner.email = null;
    this.setState({ model: statusCopy });
  };

  handleChangeComboName = (inputName, selectedItem, objName) => {
    if (selectedItem != null) {
      selectedItem.id = selectedItem.name;
    }
    this.handleChangeCombo(inputName, selectedItem, objName);
  };

  setEmployer = (employer) => {
    if (employer && employer.id) {
      let statusCopy = Object.assign({}, this.state.model);

      statusCopy.owner.idEmployer = employer.id;
      statusCopy.owner.badgeNumber = employer.ghrS_ID;
      statusCopy.owner.fullname = employer.fullname;
      statusCopy.owner.email = employer.email;
      statusCopy.owner.type = 'Saipem';
      let country = (this.state.appNationality || []).find((el) => el.id == employer.countryId);
      statusCopy.owner.nationality = country ? country.name : '';

      this.setState({ model: statusCopy, mode: 2 });
    }
  };

   excludeOption(array, optionToExclude) {
        const filteredArray = [];
        for (const item of array) {
            if (item.id !== optionToExclude) {
                filteredArray.push(item);
            }
        }
        return filteredArray;
    };

  save = () => {
    try{
    if (this.validator.allValid()) {
      let model = this.state.model;
      let editmodelCA = (this.props.listCa.itemList || []).find((y) => y.id == model.id); //RITM0946001 - Anonimizzazione Modulo Incident

      if (!this.props.isEditModal) {
        model.id = uuid();
        model.idOwner = uuid();
        //STEFANO 24/08/2021
        //model.owner.id = model.idOwner;
        //STEFANO 24/08/2021
        //console.log(model);
        }
      //STEFANO 24/08/2021
        model.owner.id = model.idOwner;
      //STEFANO 24/08/2021
      //RITM0946001 - Anonimizzazione Modulo Incident
      if (this.props.masked){
        if (model.id != null){
          if(editmodelCA != null){
            if (editmodelCA.idOwner != null && model.idOwner != null){
              if (editmodelCA.owner.fullname != model.owner.fullname || editmodelCA.owner.badgeNumber != model.owner.badgeNumber 
                || editmodelCA.owner.email != model.owner.email || editmodelCA.owner.idEmployer != model.owner.idEmployer){
                  return showNotification.error(`${entitiesLabels.ERROR}`, 'CA owner details cannot be updated for already masked personal information');
              }
            }
          }
        }
      }
      //End
      this.props.save(model);
    } else {
      if (this.validator.fieldValid('duedate') == false) {
        showNotification.warning(`${entitiesLabels.WARNING}`,
          `The Due Date must be less than or equal to the Due Date of the Car `
        );
      } else {
        showNotification.warning(`${entitiesLabels.WARNING}`,`${entitiesLabels.CA} required fields are missing  `);
      }
      this.validator.showMessages();

      this.forceUpdate();
    }
  } catch(error) { //RITM0946001 - Anonimizzazione Modulo Incident
    return showNotification.error(
      `${entitiesLabels.ERROR}`,
      getError(error, entitiesLabels.CA, this.state.isEditModal ? apioperation.PUT : apioperation.POST)
    );
  }
  finally {};
  //End
  };

  render() {
    if (this.state.model.dueDate != null) {
      var diffduedate =
        !this.props.car ||
        moment(this.props.car).isSameOrAfter(moment(this.state.model.dueDate), 'day');
    } else {
      var diffduedate = true;
    }
    const validations = {
      type: this.validator.message('type', this.state.model.owner.type, 'required'),
      fullname: this.validator.message('fullname', this.state.model.owner.fullname, 'required'),
      badgeNumber: this.validator.message(
        'badgeNumber',
        this.state.model.owner.badgeNumber,
        'required'
      ),
      email: this.validator.message('email', this.state.model.owner.email, 'required|email'),
      //nationality: this.validator.message('nationality', this.state.model.owner.nationality, 'required'),
      position: this.validator.message('position', this.state.model.owner.position, 'required'),
      duedate: this.validator.message('duedate', diffduedate, 'accepted'),
      dueDate: this.validator.message('dueDate', this.state.model.dueDate, 'required'),
      caImplemented: this.validator.message('corrective action', this.state.model.caImplemented, 'required'),
    };
    const modalHeader = {
      title: this.props.isEditModal ? 'Edit ' : 'Add new ',
      iconDescription: 'Close',
      buttonOnClick: () => this.props.toggleModal(false),
    };
    const { title, isOpenModal } = this.props;

    //RITM1197573
    const appType = (this.state.appType || []).filter(
      (el) => (el.inUse) || this.state.model?.owner.type == el.id);

    const selectedItemCombo = {
      // idDirectCause: (this.state.appDirectCause || []).find(el => el.id == this.state.model.idDirectCause),
      // idDirectCauseSubCategory: (this.state.appDirectCauseSubCategory || []).find(el => el.id == this.state.model.idDirectCauseSubCategory),
      // idRootCause: (this.state.appRootCause || []).find(el => el.id == this.state.model.idRootCause),
      // idRootCauseSubCategory: (this.state.appRootCauseSubCategory || []).find(el => el.id == this.state.model.idRootCauseSubCategory),

      nationality: (this.state.appNationality || []).find(
        (el) => el.name == this.state.model.owner.nationality
      ),
      type: (appType || []).find((el) => el.id == this.state.model.owner.type), //RITM1197573
      idStatus: (this.props.appStatus || []).find((el) => el.id == this.state.model.idStatus),
    };

    return this.state.mode == 1 ? (
      <FindGHRSEmployer
        isOpenModal={isOpenModal}
        onCancel={this.handleChangeMode}
        onOk={this.setEmployer}
      />
    ) : (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => {
          return false;
        }}
      >
        <ModalHeader className="margin-modal" {...modalHeader}>
          <p>{title || ''}</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          <div className="bx--grid--full-width">
            <div className="bx--row">
              <div className="bx--col--md-12 bx--col-lg-12">
                <FormGroup legendText="Corrective action to be implemented * (The mention of names and surnames must be done only if strictly necessary)">
                  <TextArea
                    maxLength={5000}
                    id="caImplemented"
                    placeholder="Input Corrective action"
                    value={this.state.model.caImplemented || ''}
                    onChange={(el) => this.updateState('caImplemented', el.target.value, 'model')}
                    hideLabel={true}
                    labelText=""
                    light
                    rows={4}
                    cols={200}
                    invalid={validations.caImplemented != null}
                    />
                  {validations.caImplemented}
                </FormGroup>
              </div>
              <div className="bx--col-md-8 bx--col-lg-6">
                <FormGroup legendText="Find Owner on GHRS*">
                <div className="bx--row">
                <div class="incident-GHRS-button">
                  <Button
                      kind="primary"
                      className="bx--col"
                      onClick={() => this.handleChangeMode(1)}
                      disabled={this.props.masked} //RITM0946001 - Anonimizzazione Modulo Incident
                    >
                      GHRS research
                    </Button>
                  </div>
                  <div>
                    <Button
                      iconDescription="Remove Owner"
                      tooltipPosition="top"
                      tooltipAlignment="center"
                      hasIconOnly
                      renderIcon={Close16}
                      onClick={() => this.deleteEmployer()}
                      className="search--custom-button"
                      disabled={this.props.masked} //RITM0946001 - Anonimizzazione Modulo Incident
                    />
                  </div>          
                  </div>           
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Type*">
                  {appType == null ? ( //RITM1197573
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      id="type"
                      placeholder="Select"
                      name="type"
                      alt="owner"
                      key={this.state.model.owner?.type}
                      onChange={this.handleChangeCombo}
                      itemToString={(item) => (item ? item.name : '')}
                      initialSelectedItem={selectedItemCombo.type}
                      //items={this.state.appType} //RITM0864398
                      items={appType ? this.excludeOption(appType, 'SAP') : []} //RITM1197573
                      disabled={this.state.model.owner.idEmployer != null}
                      invalid={validations.type != null}
                    />
                  )}
                  {validations.type}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Owner Full name*">
                  <TextInput
                    id="txt-fullname"
                    name="fullname"
                    alt="owner"
                    placeholder="Input full name"
                    value={this.state.model.owner.fullname || ''}
                    onChange={this.handleChangeModel}
                    type="text"
                    hideLabel={true}
                    labelText=""
                    key={this.state.model.owner.owner?.fullname}
                    disabled={this.state.model.owner.idEmployer != null || this.props.masked} //RITM0946001 - Anonimizzazione Modulo Incident
                    invalid={validations.fullname != null}
                    title="&#9888; Do Not use Personal Accounts"

                  />
                  {validations.fullname}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Owner Badge number*">
                  <TextInput
                    id="badgeNumber"
                    name="badgeNumber"
                    alt="owner"
                    placeholder="Input badge number"
                    value={this.state.model.owner.badgeNumber || ''}
                    onChange={this.handleChangeModel}
                    type="text"
                    hideLabel={true}
                    labelText=""
                    key={this.state.model.owner?.badgeNumber}
                    disabled={this.state.model.owner.idEmployer != null || this.props.masked} //RITM0946001 - Anonimizzazione Modulo Incident
                    invalid={validations.badgeNumber != null}
                  />
                  {validations.badgeNumber}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Owner Email* (Personal Email Addresses are not allowed​)">
                  <TextInput
                    id="email"
                    name="email"
                    alt="owner"
                    key={this.state.model.owner.owner?.id}
                    placeholder="Input email"
                    value={this.state.model.owner.email || ''}
                    onChange={this.handleChangeModel}
                    type="text"
                    hideLabel={true}
                    labelText=""
                    title="&#9888; Do Not use Personal Accounts"
                    disabled={this.state.model.owner.idEmployer != null || this.props.masked} //RITM0946001 - Anonimizzazione Modulo Incident
                    invalid={validations.email != null}
                    
                  />
                  {validations.email}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Owner Nationality">
                  {this.state.appNationality == null ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      id="nationality"
                      placeholder="Select"
                      name="nationality"
                      alt="owner"
                      onChange={this.handleChangeComboName}
                      itemToString={(item) => (item ? item.name : '')}
                      initialSelectedItem={selectedItemCombo.nationality}
                      items={this.state.appNationality}
                      disabled={this.state.model.owner.idEmployer != null}
                      key={this.state.model.owner?.nationality != null}
                      //invalid={validations.nationality != null}
                    />
                  )}
                  {/* {validations.nationality} */}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Position *">
                  <TextInput
                    id="position"
                    name="position"
                    alt="owner"
                    placeholder="Input position"
                    value={this.state.model.owner.position || ''}
                    onChange={this.handleChangeModel}
                    type="text"
                    hideLabel={true}
                    labelText=""
                    invalid={validations.position != null}
                  />
                  {validations.position}
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Status">
                  {this.props.appStatus == null ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      id="idStatus"
                      placeholder="Select"
                      name="idStatus"
                      alt="model"
                      onChange={this.handleChangeCombo}
                      itemToString={(item) => (item ? item.caManagementName : '')}
                      initialSelectedItem={selectedItemCombo.idStatus}
                      items={this.props.appStatus}
                      disabled={true}
                    />
                  )}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Due Date*">
                  <DateTimePicker
                    value={this.state.model.dueDate}
                    type="date"
                    placeholder={DateFormat}
                    name="dueDate"
                    alt="model"
                    invalid={validations.dueDate != null || validations.duedate != null}
                    onChange={this.updateStateDP}
                    className="open-up"
                  />
                  {validations.dueDate}
                  {validations.duedate ? (
                    <div className="srv-validation-message">
                      The Due Date must be less than or equal to the Due Date of the Car
                    </div>
                  ) : null}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Due Date Change Notes">
                  <TextInput
                    id="dueDateChangeNotes"
                    name="dueDateChangeNotes"
                    alt="model"
                    placeholder="Input change notes"
                    value={this.state.model.dueDateChangeNotes || ''}
                    onChange={this.handleChangeModel}
                    type="text"
                    hideLabel={true}
                    labelText=""
                  />
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.save()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}
